import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'GridModeComponent',
      'PriceRangeComponent',
      'ShortcutComponent',
      'ListingHeadComponent',
      'LookbookComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'CarouselComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'WishlistComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'JournalComponent',
      'InfiniteScrollTextComponent',
      'SocialComponent',
      'SeoTextComponent'
    ];
  }


  //the only way to preload only some module is to define import statically
  static get PRELOAD_MAP() {
    return {
      FiltersComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-FiltersComponent" */
          "../components/FiltersComponent"
          )
      },
      ListingHeadComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-ListingHeadComponent" */
          "../components/ListingHeadComponent"
          )
      },
      SearchComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-SearchComponent" */
          "../components/SearchComponent"
          )
      },
      CarouselComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-CarouselComponent" */
          "../components/CarouselComponent"
          )
      },
      ListingEditorialComponent: () => {
        return import(
          /* webpackPreload: true */
          /* webpackChunkName: "component-ListingEditorialComponent" */
          "../components/ListingEditorialComponent"
          )
      }
    }
  };
}
